// extracted by mini-css-extract-plugin
module.exports = {"error":"error-module__error___HnGNT","header":"error-module__header___xLlI9"};